import firebase from "firebase";
import { OlabItem } from "./olabitem.js";
// import { OlabUtils } from "./olabutils.js";

class OlabStrain extends OlabItem {
  static getCreateItemConverter() {
    // Firestore data converter
    let olabItemConverter = {
      toFirestore: function(item) {
        return {
          editDisplayState: item.editDisplayState,
          olab_id: item.olab_id,
          olab_type: item.olab_type,
          name: item.name,
          name_uc: item.name_uc,
          parent_id: item.parent_id,
          project_id: item.project_id,
          microbe_type: item.microbe_type,
          source: item.source,
          creator: item.creator,
          creator_uc: item.creator_uc,
          mutations: item.mutations,
          antibiotic_resistance: item.antibiotic_resistance,
          plasmid_id: item.plasmid_id,
          show_genes: item.show_genes,
          storage: item.storage,
          wgs_confirmed: item.wgs_confirmed,
          desc: item.desc,
          desc_hyperlink: item.desc_hyperlink,
          download_file: item.download_file,
          created_date: firebase.firestore.FieldValue.serverTimestamp()
        };
      },
      fromFirestore: function(snapshot, options) {
        const data = snapshot.data(options);
        return new OlabItem(data);
      }
    };
    return olabItemConverter;
  }

  static getUpdateItemConverter() {
    // Firestore data converter
    let olabItemConverter = {
      toFirestore: function(item) {
        return {
          editDisplayState: item.editDisplayState,
          // olab_id: item.olab_id,
          // olab_type: item.olab_type,
          name: item.name,
          name_uc: item.name_uc,
          parent_id: item.parent_id,
          project_id: item.project_id,
          microbe_type: item.microbe_type,
          source: item.source,
          creator: item.creator,
          creator_uc: item.creator_uc,
          mutations: item.mutations,
          antibiotic_resistance: item.antibiotic_resistance,
          plasmid_id: item.plasmid_id,
          show_genes: item.show_genes,
          storage: item.storage,
          wgs_confirmed: item.wgs_confirmed,
          desc: item.desc,
          desc_hyperlink: item.desc_hyperlink,
          download_file: item.download_file,
          updated_date: firebase.firestore.FieldValue.serverTimestamp()
        };
      },
      fromFirestore: function(snapshot, options) {
        const data = snapshot.data(options);
        return new OlabItem(data);
      }
    };
    return olabItemConverter;
  }
}

export { OlabStrain };
